import React from 'react';
import Select from 'react-select';

type OptionsProps = {
  value: string;
  label: string;
};

type SelectInputProps = {
  name: string;
  label: string;
  placeholder: string;
  disabled?: boolean;
  loading?: boolean;
  options?: OptionsProps[];
  wrapperClass?: string;
  Controller: any;
  control: any;
  errors: any;
  defaultValue?: any;
};

export default function MultiSelectInput({
  name,
  label,
  placeholder,
  disabled = false,
  loading = false,
  options,
  wrapperClass,
  Controller,
  control,
  errors,
  defaultValue,
  ...rest
}: SelectInputProps) {
  return (
    <div className={`${wrapperClass} flex flex-col items-start pb-4 text-sm`}>
      {label && (
        <label className="text-neutral7 uppercase" htmlFor={name}>
          {label}
        </label>
      )}
      <Controller
        control={control}
        defaultValue={defaultValue}
        name={name}
        {...rest}
        render={({ field: { onChange, value } }: any) => {
          return (
            <Select
              className="select w-full"
              placeholder={placeholder}
              isDisabled={disabled}
              isLoading={loading}
              isClearable
              isSearchable
              name={name}
              options={options}
              closeMenuOnSelect
              value={options?.find(
                (opt) => opt?.value?.toString() === value && value[0]?.toString()
              )}
              onChange={(val) => onChange(val.map((c) => c.value))}
              isMulti
              defaultValue={defaultValue}
            />
          );
        }}
      />

      {errors[name] && (
        <span className="error" role="alert">
          {errors[name].message}
        </span>
      )}
    </div>
  );
}
